import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import VisaSearch from "./components/VisaSearch";
import HowItWorks from "./components/HowItWorks";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import Stats from "./components/Stats";
import FinalCTA from "./components/FinalCTA";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import ChatbotWidget from "./components/ChatbotWidget";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ApplyPage from "./pages/ApplyPage";
import QuotePage from "./pages/QuotePage";
import PricingPage from "./pages/PricingPage";
import EligibilityPage from "./pages/EligibilityPage";
import TrackingPage from "./pages/TrackingPage";
import DocumentUploadPage from "./pages/DocumentUploadPage";
import PaymentPage from "./pages/PaymentPage";
import CountryPage from "./pages/CountryPage";
import ComparePage from "./pages/ComparePage";
import { BlogListPage, BlogPostPage } from "./pages/BlogPage";
import { LegalIndexPage, LegalDetailPage } from "./pages/LegalPages";
import VisaCalendarPage from "./pages/VisaCalendarPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";

function HomePage() {
  return (
    <>
      <main>
        <HeroSection />
        <VisaSearch />
        <HowItWorks />
        <WhyChooseUs />
        <Testimonials />
        <Stats />
        <FinalCTA />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}

// Scroll to top on route change (fixes browser back/forward)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
        <ScrollToTop />
        <div className="min-h-screen bg-slate-50">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/apply/:id/documents" element={<DocumentUploadPage />} />
            <Route path="/apply/:id/payment" element={<PaymentPage />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/eligibility" element={<EligibilityPage />} />
            <Route path="/tracking/:id" element={<TrackingPage />} />
            <Route path="/visa/:code" element={<CountryPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/visa-calendar" element={<VisaCalendarPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/legal" element={<LegalIndexPage />} />
            <Route path="/legal/:slug" element={<LegalDetailPage />} />
          </Routes>
          <ChatbotWidget />
        </div>
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
